import axios from 'axios'

// const local = 'http://localhost:5000'
const local = 'https://api.snusconicotine.com'

const api = axios.create({
  baseURL: `${local}/api`,
  withCredentials: true, // ← send cookies on every request
})

export default api
